import React from 'react'

import { BoxProps } from './types'
import { BoxComponent } from './styles'

const Box = ({ children, ...props }: BoxProps & React.HTMLAttributes<HTMLDivElement>) => (
  <BoxComponent data-testid="box" {...props}>
    {children}
  </BoxComponent>
)

export default Box
